<template>

  <div class="comment" v-if="!deleted">
    <div class="avatar">
      <i class="fas fa-user-circle" v-if="!currentUser || currentUser.id != comment.user_id"></i>
      <img v-else src="/static/img/avatar.png" alt="Avatar">
    </div>
    <div class="body">
      <div class="head">
        <strong v-if="!currentUser || currentUser.id != comment.user_id">{{comment.user_first_name}} {{comment.user_last_name}}</strong>
        <strong v-else>You</strong>
        <span style="margin-left:20px;">{{friendlyDate}}</span>
        <button class="btn btn-danger btn-sm pull-right" v-if="showDelete" v-on:click="deleteComment()"><i class="fas fa-trash"></i> &nbsp; Delete</button>
      </div>
      <div class="text">
        <strong>"</strong>{{comment.body}}<strong>"</strong>
      </div>
    </div>
  </div><!-- /div -->

</template>

<script>

  import { mapState, mapActions, mapGetters } from 'vuex';
  import _ from 'underscore'



  export default {
    props: {
      comment: Object,
      showDelete: Boolean,
      blogArticleId: Number,
    },

    computed: {
      ...mapState([
        'currentUser',
      ]),
      ...mapGetters({
        allBlogPosts: 'allBlogPosts',
      }),
      friendlyDate() {
        let d = new Date(this.comment.created_at);

        return d.toLocaleDateString() + ' - ' + d.getHours() + ':' + d.getMinutes();
      }
    },
    methods: {
      deleteComment() {
        var self = this;
        this.$store.dispatch('deleteComment', {
          comment: this.comment, callback: (obj) => {
            self.deleted = true;
            Toast.success('Comment deleted');
          }
        });
      }
    },

    data() {
      return {
        deleted: false,
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .comment { position: relative; padding-left: 50px; padding-top:15px;padding-bottom:15px;border-bottom:1px solid #EEEEEE;}
  .comment .avatar { position: absolute; top: 18px; left: 0px; }
  .comment .avatar img { width: 32px; border-radius: 16px; }
  .comment .avatar i { font-size: 32px; color: #4285f4; }
  .comment .body { }
  .comment .body .head {margin-bottom:5px;}
  .comment .body .text {}
  .comment .body .head .btn-danger {display:none;}
  .comment:hover .body .head .btn-danger {display:block;}
</style>



// WEBPACK FOOTER //
// BlogComment.vue?952162b6